import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

import { HttpClient } from '@angular/common/http';

import { AppointmentsModel } from '../Models/appointment.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DatePipe } from '@angular/common';
import { AuthService } from 'app/auth/auth.service';
import { BillingserviceService } from 'app/billing/billingService.service';

export interface DialogData {
  // id: string;
  // name: string;
  // usertypeid: number;
  // userid: number;
  // prelocationid: number;
  // usertype: string;
}
 
@Component({
  selector: 'app-appointment-list',
  templateUrl: './appointment-list.component.html',
  styleUrls: ['./appointment-list.component.scss']
})
export class AppointmentListComponent implements OnInit {
  showspinner = false;

  dataSource = new MatTableDataSource<AppointmentsModel>();
  selecteddate:any;
  minseletDate:any;
  constructor( public dialogRef: MatDialogRef<AppointmentListComponent>,
    public http: HttpClient,
    public dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public opdvistService: OpdVisitService,
    public datepipe: DatePipe,
    public authService: AuthService,
    public opdvisitService: OpdVisitService,public datePipe :DatePipe,public billingservice:BillingserviceService) { 
      //dialogRef.disableClose = true;
    }
 
    displayedColumns: string[] = ['patientId', 'apptTime', 'patientName', 'age',
     'sex', 'address', 'contactNo', 'apptType', 'doctorName','takenBy',
     'referredDoctor','remarks'];

   // dataSource: UserTypeList[] = []; 

  ngOnInit() {

    this.dataSource.data = this.opdvistService.appointments;
    console.log(this.opdvistService.appointments);
    //alert({'appointments':this.opdvistService.appointments.length});
    this.selecteddate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.minseletDate= this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
  }
  filterbydate(selecteddate: string) {
    this.showspinner = true;

     let container = selecteddate.split("/", 3);

    let selecteddate_converted = container[1] + "/" + container[0] + "/" + container[2];

    this.selecteddate = this.datepipe.transform(selecteddate_converted, "yyyy-MM-dd");

    this.getapplist();
   
  }


  getapplist() {
   
    this.billingservice.getappointment(this.selecteddate, this.authService.Loggeduser.branchid).
        subscribe(data => this.success_appointments(data), err => this.failedpatient_appointments(err));
    
  }
  success_appointments(data) {
    this.showspinner = false;
    this.opdvisitService.appointments = data;
    this.dataSource.data = this.opdvistService.appointments;

  }
  failedpatient_appointments(err) {
    this.showspinner = false;
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  showonlyfirst20(fulladdress: string) {
    if (fulladdress == "" || fulladdress == null) {
      return "";
    } 
    else if(fulladdress.length > 20) {
      return fulladdress.substring(0, 20) + "...";
    }
    else {
      return fulladdress;
    }

  }

  convertnulltostring(value: string){
    if (value == "" || value == null) {
      return "";
    }
    else {
      return value;
    }
  }

  showonlyfirst10(fullremark: string) {
    if (fullremark == "" || fullremark == null) {
      return "";
    }
    else if(fullremark.length> 10){
return fullremark.substring(0, 10) + "...";
    }
    else {
      return fullremark;
    }

  }
  onNoClick(): void {
    //this.dashboardService.popup_cancel = true;
    this.dialogRef.close();
    this.opdvisitService.apptdetail={};
  } 

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
   
  }
  gotoopd_visit(appointment: AppointmentsModel){
     this.opdvisitService.appoitnmentusername =null;
    if (Date.parse(this.datePipe.transform(this.selecteddate, "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.minseletDate, "yyyy-MM-dd").toString())){
      this.opdvisitService.appoitnmentusername=appointment.doctorName;
      this.opdvisitService.getapptdetails(appointment.appId);
      this.opdvisitService.pendingAppointment=true;
      this.dialogRef.close(appointment);
    }else{
      this.dashboardService.openSnackBar("Future opdvisit Not Allowed ","ok");
    }
   
  }
 
  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
  
  formatapptime(appttime: string){
   if (appttime == null) {
      // do nothing
      //09:30:00.000000
    }
    else {
     // "12:10:00.0000000"
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":",3);
     // return hr_min[0] + ":" + hr_min[1];

     

     if (+hr_min[0] == 12 && +hr_min[1] == 0o0){
      console.log ("app time " + hr_min[0]);
      return hr_min[0] + ":" + "00" + " pm";
     }

     else if (+hr_min[0] < 12) {
        return hr_min[0] + ":" + hr_min[1] + " am";
      }
      else {
        if(+hr_min[0] == 12){
          return +hr_min[0] + ":" + hr_min[1] + " pm";
        }
        
else if(+hr_min[0] - 12 <= 9){
  return  ("0") + (+hr_min[0] - 12) + ":" + hr_min[1] + " pm";
}
else {
    return (+hr_min[0] - 12) + ":" + hr_min[1] + " pm";
}
      
      }
    }
  }

}
